import { render, staticRenderFns } from "./OrganizationActions.vue?vue&type=template&id=64450f80&scoped=true&"
import script from "./OrganizationActions.vue?vue&type=script&lang=ts&"
export * from "./OrganizationActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64450f80",
  null
  
)

export default component.exports